module.exports = __webpack_public_path__ + "16dae881bd341899b7952cdfd2d9706e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/nvidia_2023_chart.png
// module id = 1708
// module chunks = 0